import Modal from '@layouts/Modal';
import ErrorMessage from '@src/ui/elements/form/ErrorMessage';
import { firstError, hasError } from '@src/utils/errorMessageUtils';
import { Editor } from '@tiptap/react';
import React from 'react';

export type InsertTableModalErrorResponse = {
  value?: string[];
};

interface EditorInsertTableModalProps {
  isOpen: boolean;
  editor: Editor | null;
  tableRows: string;
  tableCols: string;
  onTableRowsChange: (rows: string) => void;
  onTableColsChange: (cols: string) => void;
  onSubmit: (editor: Editor | null) => void;
  onClose: () => void;
  errors?: InsertTableModalErrorResponse;
}

export const EditorInsertTableModal: React.FC<EditorInsertTableModalProps> = ({
  isOpen,
  editor,
  tableRows,
  tableCols,
  onTableRowsChange,
  onTableColsChange,
  onSubmit,
  onClose,
  errors,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <Modal width='500px'>
      <div className='flex grow flex-col gap-8 px-8 py-10'>
        <div className='border-b border-b-gray-350 pb-4'>
          <h2 className='text-lg font-semibold'>表を挿入する</h2>
          <button
            className='closeButton'
            onClick={onClose}
          >
            &times;
          </button>
        </div>
        <div className='modalBody'>
          <div className='fieldGroup'>
            <label>行数</label>
            <input
              type='number'
              value={tableRows}
              onChange={(e) => onTableRowsChange(e.target.value)}
              className={`rounded border px-3 py-2 focus:outline-none ${
                hasError(errors?.value) ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-white'
              }`}
            />
          </div>
          <div className='fieldGroup'>
            <label>列数</label>
            <input
              type='number'
              value={tableCols}
              onChange={(e) => onTableColsChange(e.target.value)}
              className={`rounded border px-3 py-2 focus:outline-none ${
                hasError(errors?.value) ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-white'
              }`}
            />
          </div>
          <ErrorMessage>{firstError(errors?.value)}</ErrorMessage>
        </div>
        <div className='modalFooter'>
          <button
            className='editorButton cancelButton'
            onClick={onClose}
          >
            キャンセル
          </button>
          <button
            className='editorButton insertButton'
            onClick={() => onSubmit(editor)}
          >
            挿入する
          </button>
        </div>
      </div>
    </Modal>
  );
};
